import {useOutletContext} from '@remix-run/react'
import React from 'react'
import {useReportWidgetSeen} from '~/hooks/analytic-hooks'
import type {RootAndListContext} from '~/types'

const ReviewCommentSection = () => {
  const {
    dataResponse: {reviewComment},
  } = useOutletContext<RootAndListContext>()
  const [widgetRef] = useReportWidgetSeen({
    widget_name: 'review-comment-section',
    widget_place: 'middle',
  })
  const showReview = reviewComment && reviewComment?.comment && reviewComment?.name && reviewComment?.city

  return (
    showReview && (
      <div className="flex flex-col gap-3" ref={widgetRef}>
        <div className="flex min-h-40 flex-col rounded-xl bg-blue-100 p-4">
          <q className="w-1/2 text-xl italic tablet:w-full">{reviewComment.comment}</q>
          <div className="mt-auto flex items-center gap-1 text-base font-light text-gray-900">
            {reviewComment.name}
            <em className="-mt-0.5 text-2xl">•</em>
            {reviewComment.city}
          </div>
        </div>
      </div>
    )
  )
}

export default ReviewCommentSection
